import KeysApi from "@/services/api/keysApi.js";
import cardSettings from "./cardStyle.js";

const KeysApiService = new KeysApi();

export default {
  data() {
    return {
      card: null,
      stripe: null,
    };
  },

  methods: {
    getKey,
    mountCardForm,
    submitCard,
  },

  mounted() {
    this.getKey();
  },
};

async function getKey() {
  try {
    const { data } = await KeysApiService.getClientKeys();

    this.stripe = Stripe(data.stripe_api_key);
    this.mountCardForm();
  } catch (error) {
    this.$swal("Attention", error.response.data.error_message);
  }
}

async function mountCardForm() {
  const elements = this.stripe.elements(),
    card = elements.create("card", cardSettings);

  await this.$nextTick();
  card.mount("#card-element");
  this.card = card;
}

async function submitCard() {
  const errorElement = document.getElementById("card-errors"),
    { token, error } = await this.stripe.createToken(this.card);

  if (error) {
    errorElement.textContent = error.message;
    return false;
  }

  errorElement.textContent = "";
  return token.id;
}
